import { IconChevronDown, IconChevronUp } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { MouseEvent } from 'react';

type BuildLogToolbarProps = {
  isBuildRunning: boolean;
  shouldBreakLines: boolean;
  shouldFollowLog: boolean;
  onBreakLineToggle: (isEnabled: boolean) => void;
  onFollowLog: (isFollow: boolean) => void;
  onScrollButtonClick: (direction: 'up' | 'down') => void;
};

const StreamingBuildLogToolbar = ({
  isBuildRunning,
  shouldBreakLines,
  shouldFollowLog,
  onBreakLineToggle,
  onFollowLog,
  onScrollButtonClick,
}: BuildLogToolbarProps) => {
  const onBreakLineToggleClick = (e: MouseEvent<HTMLButtonElement>, isEnabled: boolean) => {
    e.stopPropagation();
    onBreakLineToggle(isEnabled);
  };

  return (
    <Box position="absolute" inset="0" pointerEvents="none" display="flex" justifyContent="end">
      <Box
        pointerEvents="auto"
        display="flex"
        position="sticky"
        bottom="16"
        className="buildLogToolbar"
        flexDirection="column"
        gap="8"
      >
        <Box display="flex" justifyContent="flex-end">
          <button
            className={`no-right-radius${shouldBreakLines ? '' : ' is-selected'}`}
            onClick={(e) => onBreakLineToggleClick(e, false)}
            title="Don't break lines"
            type="button"
          >
            <svg viewBox="0 0 19 17">
              <path d="m18 2h-17c-.552 0-1-.448-1-1s.448-1 1-1h17c.553 0 1 .448 1 1s-.447 1-1 1z" />
              <path d="m10 7h-9c-.552 0-1-.448-1-1s.448-1 1-1h9c.553 0 1 .448 1 1s-.447 1-1 1z" />
              <path d="m18 12h-17c-.552 0-1-.447-1-1s.448-1 1-1h17c.553 0 1 .447 1 1s-.447 1-1 1z" />
              <path d="m14 17h-13c-.552 0-1-.447-1-1s.448-1 1-1h13c.553 0 1 .447 1 1s-.447 1-1 1z" />
            </svg>
          </button>
          <button
            className={`no-left-radius${shouldBreakLines ? ' is-selected' : ''}`}
            onClick={(e) => onBreakLineToggleClick(e, true)}
            title="Break lines"
            type="button"
          >
            <svg viewBox="0 0 19 17">
              <path d="m18 2h-17c-.552 0-1-.448-1-1s.448-1 1-1h17c.553 0 1 .448 1 1s-.447 1-1 1z" />
              <path d="m18 7h-17c-.552 0-1-.448-1-1s.448-1 1-1h17c.553 0 1 .448 1 1s-.447 1-1 1z" />
              <path d="m18 12h-17c-.552 0-1-.447-1-1s.448-1 1-1h17c.553 0 1 .447 1 1s-.447 1-1 1z" />
              <path d="m18 17h-17c-.552 0-1-.447-1-1s.448-1 1-1h17c.553 0 1 .447 1 1s-.447 1-1 1z" />
            </svg>
          </button>
        </Box>
        <Box display="flex" gap="8">
          {isBuildRunning ? (
            <button
              aria-pressed={shouldFollowLog}
              className={`follow-button${shouldFollowLog ? ' is-selected' : ''}`}
              onClick={() => onFollowLog(!shouldFollowLog)}
              title="Follow log"
              type="button"
            >
              Follow
            </button>
          ) : null}
          <button onClick={() => onScrollButtonClick('up')} title="Go to top" type="button">
            <IconChevronUp />
          </button>
          <button onClick={() => onScrollButtonClick('down')} title="Go to bottom" type="button">
            <IconChevronDown />
          </button>
        </Box>
      </Box>
    </Box>
  );
};

export default StreamingBuildLogToolbar;
